<template>
  <button type="button" @click="handleButtonClick">
    <n-icon-base v-if="isPlaying">
      <n-icon-pause />
    </n-icon-base>
    <n-icon-base v-else>
      <n-icon-play />
    </n-icon-base>
  </button>
</template>

<style lang="scss" scoped>

button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  border: 2px solid var(--color--secondary);
  padding: 0;
  color: var(--color--secondary);
  background: transparent;
}

</style>

<script>
import IconBase from './icons/IconBase'
import IconPause from './icons/IconPause.vue'
import IconPlay from './icons/IconPlay.vue'

export default {
  props: {
    isPlaying: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'n-icon-base': IconBase,
    'n-icon-pause': IconPause,
    'n-icon-play': IconPlay
  },
  methods: {
    handleButtonClick (e) {
      if (this.isPlaying) {
        this.$emit('pause')
      } else {
        this.$emit('play')
      }
    }
  }
}
</script>
